/**
 * AI Adoption Readiness Assessment — 12-domain scoring + 30/60/90 roadmap.
 */

const DOMAINS = [
  'governance', 'policy', 'data_readiness', 'security', 'privacy', 'vendor_management',
  'workforce_training', 'evaluation_maturity', 'monitoring_maturity', 'incident_response',
  'executive_oversight', 'compliance_readiness',
];

export const aiReadiness = {
  async aiReadiness() {
    let res = { data: [] };
    try { res = await API.getAiReadinessList(); } catch (e) { /* empty */ }
    const items = res.data || [];
    const latest = items[0];

    const summary = latest ? `
      <div class="stats-row">
        <div class="stat-card info"><div class="stat-value">${latest.readiness_score}%</div><div class="stat-label">Readiness Score</div></div>
        <div class="stat-card success"><div class="stat-value">${App.formatLabel(latest.maturity_level)}</div><div class="stat-label">Maturity Level</div></div>
        <div class="stat-card warning"><div class="stat-value">${(latest.priority_gaps || []).length}</div><div class="stat-label">Priority Gaps</div></div>
      </div>
      <div class="card" style="margin-top:16px">
        <div class="card-header"><h3>30 / 60 / 90-Day Roadmap — ${latest.name}</h3></div>
        <div class="form-grid-2">
          ${[30, 60, 90].map(d => `
            <div class="form-group"><label>${d} days</label>
              <ul>${((latest.roadmap || {})[d] || []).map(i => `<li>${i}</li>`).join('') || '<li class="muted">No actions</li>'}</ul>
            </div>`).join('')}
        </div>
      </div>` : `
      <div class="empty-state"><div class="empty-icon">&#9673;</div>
      <p>No readiness assessment yet. Create one to score adoption readiness across 12 domains.</p></div>`;

    const history = items.length > 1 ? `
      <div class="card" style="margin-top:16px">
        <div class="card-header"><h3>History</h3></div>
        <div class="table-container"><table class="data-table">
          <thead><tr><th>Name</th><th>Score</th><th>Maturity</th><th>Assessed</th></tr></thead>
          <tbody>${items.map(i => `<tr><td>${i.name}</td><td>${i.readiness_score}%</td>
            <td>${App.formatLabel(i.maturity_level)}</td><td>${App.formatDate(i.updated_at)}</td></tr>`).join('')}</tbody>
        </table></div>
      </div>` : '';

    return `
      <div class="page-header">
        <div><h2>AI Adoption Readiness</h2><p>Score readiness to accelerate safe AI adoption across 12 governance domains</p></div>
        <button class="btn btn-primary" data-action="Pages.newReadiness">+ New Assessment</button>
      </div>
      ${summary}
      ${history}`;
  },

  newReadiness() {
    const rows = DOMAINS.map(d => `
      <div class="form-group">
        <label>${App.formatLabel(d)}</label>
        ${App.maturitySelect('rd-' + d, 3)}
      </div>`).join('');
    const body = `
      <div class="form-group"><label>Assessment name *</label>
        <input id="rd-name" class="form-control" placeholder="e.g. 2026 AI Adoption Readiness"></div>
      <p class="muted" style="font-size:13px">Rate each domain 1 (Initial) to 5 (Optimized).</p>
      <div class="form-grid-2">${rows}</div>`;
    const footer = `
      <button class="btn btn-outline" data-action="App.closeModal">Cancel</button>
      <button class="btn btn-primary" data-action="Pages.submitReadiness">Score Readiness</button>`;
    App.openModal('New Readiness Assessment', body, footer);
  },

  async submitReadiness() {
    const name = (document.getElementById('rd-name')?.value || '').trim();
    if (!name) { App.toast('Assessment name is required', 'error'); return; }
    const domain_scores = {};
    for (const d of DOMAINS) {
      const v = parseInt(document.getElementById('rd-' + d)?.value || '', 10);
      if (Number.isFinite(v)) domain_scores[d] = v;
    }
    try {
      await API.createAiReadiness({ name, domain_scores });
      App.closeModal();
      App.toast('Readiness assessment scored', 'success');
      App.navigate('ai-readiness');
    } catch (e) { App.toast(e.message || 'Failed to create assessment', 'error'); }
  },
};
